import React from 'react'
import Text, { FontStyle } from '~/components/core/Text'
import { light } from '~/constants/theme'
import { ItemWrapper } from '~/pages/Settings/SnippetSettingsStyles'

import { Pbx } from '@mangovoice/types'

interface PbxListItemProps {
  active?: boolean
  isSelected?: boolean
  bottom?: boolean
  pbx: Pbx
  onSelect: (pbx: Pbx) => void
}
export const PbxListItem = ({
  active,
  bottom,
  pbx,
  onSelect,
}: PbxListItemProps) => {
  const { name } = pbx
  return (
    <ItemWrapper bottom={bottom} onClick={() => onSelect(pbx)} active={active}>
      <Text color={light.dark900} fontStyle={FontStyle.Normal} text={name} />
    </ItemWrapper>
  )
}
